const legacySchemaBoiler = {
    Type: null,
    Name: null,
    CustomValues: null,
    Label: null,
    RepeatGroup: null,
    Required: null,
    RequiredPhoto: null,
    RequiredPhotoMultimediaAssetId: null,
    Value: null
}
export default legacySchemaBoiler